package com.fireavert.properties.shared.data_models

enum class PmsType {
    None,
    Yardi,
    RealPage,
    AppFolio,
    Entrata,
    ResMan,
    OneSite,
    MRI,
    RentManager
}